import { createContext } from 'react';

export type ScannerPanelContextType = {
	open: boolean;
	openPanel: () => void;
	closePanel: () => void;
	togglePanel: () => void;
	setPrefillQuery: (q: string) => void;
	prefillQuery: string;
};

export const ScannerPanelContext = createContext<ScannerPanelContextType | undefined>(undefined);
